require("./galhad_galhadLtr_site_randomListcomponenta.less")
require("./galhad_galhadLtr_site_randomListcomponenta_redesign.less")
import * as axios from "axios"
import { addAxiosDateTransformerSettings } from "../../../../../utils/network/axiosDateTransformer"
import { SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink"
import { getImagesSrc } from "../../../../commonComponents/inline/siteSimpleImage";
import { getFrontImageUrl } from "../../../../../front/staticServerRendering/frontImage";
import { ImageSize } from "../../../../../constants/imageSizes";

interface GalhadArticle {
    id: string;
    title: string;
    roof: string;
    promotionImageUrl: string;
    publishedLink?: string;
}

interface GalhadRandomListComponentaProps {
    numberOfItemsToDisplay: number;
    randomizeIntervalSeconds: number;
    enableLoadMore: boolean;
    isRandomOrder: boolean;
    imagesDomain: string;
    isLTR?: boolean;
    newDesign?: boolean;
}

interface GalhadRandomListState {
    articles: GalhadArticle[];
    displayedArticles: GalhadArticle[];
    isLoading: boolean;
    currentDisplayCount: number;
}

export class GalhadRandomListComponenta extends React.Component<GalhadRandomListComponentaProps, GalhadRandomListState>{
    public static siteScriptName = "GalhadRandomListComponenta"
    private randomizeTimer: number | null = null;
    private scrollListenerAttached: boolean = false;

    constructor(props: GalhadRandomListComponentaProps) {
        super(props);
        this.state = {
            articles: [],
            displayedArticles: [],
            isLoading: true,
            currentDisplayCount: props.numberOfItemsToDisplay
        };
    }

    componentDidMount() {
        this.fetchData();
        this.startRandomizeTimer();
        if (this.props.enableLoadMore) {
            this.attachScrollListener();
        }
    }

    componentWillUnmount() {
        this.stopRandomizeTimer();
        this.detachScrollListener();
    }

    componentDidUpdate(prevProps: GalhadRandomListComponentaProps) {
        if (prevProps.randomizeIntervalSeconds !== this.props.randomizeIntervalSeconds ||
            prevProps.isRandomOrder !== this.props.isRandomOrder) {
            this.stopRandomizeTimer();
            this.startRandomizeTimer();
        }
        if (prevProps.numberOfItemsToDisplay !== this.props.numberOfItemsToDisplay || 
            prevProps.isRandomOrder !== this.props.isRandomOrder) {
            this.setState({ currentDisplayCount: this.props.numberOfItemsToDisplay }, () => {
                this.updateDisplayedArticles();
            });
        }
        if (prevProps.enableLoadMore !== this.props.enableLoadMore) {
            if (this.props.enableLoadMore) {
                this.attachScrollListener();
            } else {
                this.detachScrollListener();
            }
            this.setState({ currentDisplayCount: this.props.numberOfItemsToDisplay }, () => {
                this.updateDisplayedArticles();
            });
        }
    }

    private startRandomizeTimer = () => {
        const { randomizeIntervalSeconds, isRandomOrder } = this.props;
        if (randomizeIntervalSeconds > 0 && isRandomOrder) {
            this.randomizeTimer = window.setInterval(() => {
                this.updateDisplayedArticles();
            }, randomizeIntervalSeconds * 1000);
        }
    }

    private stopRandomizeTimer = () => {
        if (this.randomizeTimer) {
            clearInterval(this.randomizeTimer);
            this.randomizeTimer = null;
        }
    }

    private attachScrollListener = () => {
        if (!this.scrollListenerAttached) {
            window.addEventListener('scroll', this.handleScroll);
            this.scrollListenerAttached = true;
        }
    }

    private detachScrollListener = () => {
        if (this.scrollListenerAttached) {
            window.removeEventListener('scroll', this.handleScroll);
            this.scrollListenerAttached = false;
        }
    }

    private handleScroll = () => {
        const { enableLoadMore } = this.props;
        const { articles, displayedArticles } = this.state;

        if (!enableLoadMore || displayedArticles.length >= articles.length) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = window.innerHeight;

        // בדיקה אם הגענו קרוב לתחתית העמוד (100px לפני הסוף)
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            this.loadMoreItems();
        }
    }

    private loadMoreItems = () => {
        const { articles, currentDisplayCount } = this.state;
        const { numberOfItemsToDisplay, isRandomOrder } = this.props;

        const newDisplayCount = currentDisplayCount + numberOfItemsToDisplay;
        
        this.setState({ currentDisplayCount: newDisplayCount }, () => {
            this.updateDisplayedArticles();
        });
    }

    private updateDisplayedArticles = () => {
        const { articles, currentDisplayCount } = this.state;
        const { isRandomOrder, enableLoadMore, isLTR } = this.props;
        
        if (articles.length === 0) return;

        let itemsToShow = enableLoadMore ? currentDisplayCount : this.props.numberOfItemsToDisplay;
        
        let displayed: GalhadArticle[];
        if (isRandomOrder) {
            // יצירת עותק של המערך וערבוב אקראי
            const shuffled = [...articles].sort(() => Math.random() - 0.5);
            displayed = shuffled.slice(0, Math.min(itemsToShow, articles.length));
        } else {
            // הצגה בסדר אלפביתי לפי שם
            const sorted = [...articles].sort((a, b) => {
                const locale = isLTR ? 'en' : 'he';
                return a.title.localeCompare(b.title, locale);
            });
            displayed = sorted.slice(0, Math.min(itemsToShow, articles.length));
        }
        
        const scrollY = window.pageYOffset;
        this.setState({ displayedArticles: displayed }, () => {
            window.scrollTo(window.pageXOffset, scrollY);
        });
    }

    private fetchData = () => {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        axiosInstance.get(`/iphone/json/api/article/gal_hed/get_all/`)
            .then((res: any) => {
                const articles = res.data.articles || [];
                this.setState({
                    articles: articles,
                    isLoading: false
                }, () => {
                    this.updateDisplayedArticles();
                });
            })
            .catch(err => {
                console.error("Error fetching gal_hed data:", err);
                this.setState({ isLoading: false });
            });
    }



    public render() {
        const { displayedArticles, isLoading, articles } = this.state;
        const { enableLoadMore, newDesign } = this.props;
        const hasMoreToLoad = enableLoadMore && displayedArticles.length < articles.length;

        if (isLoading) {
            return <div className="galhadRandomListGallery">טוען...</div>;
        }

        return (
            <div className={`${newDesign ? ' galhadRandomListWrapper_is_new_design' : 'galhadRandomListWrapper'}`}>
                <div className="galhadRandomListGallery">
                    {displayedArticles.map((article, index) => (
                        <SimpleLinkRenderer 
                            key={article.id || index} 
                            href={article.publishedLink}
                            className="soldierCard"
                        >
                            <div className="soldierImageContainer">
                                <div className="imageFrame">
                                    <div className="imageInner">
                                        {article.promotionImageUrl && (
                                            <img src={`${this.props.imagesDomain}/${getFrontImageUrl({publishedLink:article.promotionImageUrl}, { imageSize: ImageSize.large })}`} alt={article.title} />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="soldierRank">
                                <div className="rankLine"></div>
                                <p className="rankText">{article.roof}</p>
                                <div className="rankLine"></div>
                            </div>
                            <p className="soldierName">{article.title}</p>
                        </SimpleLinkRenderer>
                    ))}
                </div>
             
            </div>
        )
    }
}
